import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import {

  ResponsiveContainer,

  LineChart,
  Line,

  PieChart,
  Pie,
  Cell,

  BarChart,
  Bar,

  XAxis,
  YAxis,

  Tooltip,

  CartesianGrid,

  AreaChart,
  Area

} from "recharts";

const Dashboard = () => {

  const navigate = useNavigate();

  const [stats, setStats] =
    useState({});

  const [products, setProducts] =
    useState([]);

  const [customers, setCustomers] =
    useState([]);

    const [startDate, setStartDate] =
  useState("");

const [endDate, setEndDate] =
  useState("");

  // =========================================
  // FETCH DATA
  // =========================================

  const fetchDashboard = () => {

  const params =
    new URLSearchParams();

  if (startDate)
    params.append(
      "start_date",
      startDate
    );

  if (endDate)
    params.append(
      "end_date",
      endDate
    );

  fetch(
    `/api/dashboard?${params}`
  )
    .then(res => res.json())
    .then(data =>
      setStats(
        data.stats || {}
      )
    );
};

  useEffect(() => {

    fetchDashboard();

    fetch(
      "/api/products"
    )
      .then(res => res.json())
      .then(data =>
        setProducts(
          (data.products || data)
            .slice(0, 6)
        )
      );

    fetch(
      "/api/customers"
    )
      .then(res => res.json())
      .then(data =>
        setCustomers(
          (data.customers || [])
            .slice(0, 6)
        )
      );

 }, [startDate, endDate]);

  // =========================================
  // CHART DATA
  // =========================================

  const revenueData = [

    {
      month: "Jan",
      revenue: 12000
    },

    {
      month: "Feb",
      revenue: 18000
    },

    {
      month: "Mar",
      revenue: 15000
    },

    {
      month: "Apr",
      revenue: 25000
    },

    {
      month: "May",
      revenue: 22000
    },

    {
      month: "Jun",
      revenue: 30000
    }

  ];

  const rentalStatusData = [

    {
      name: "Returned",
      value: 35
    },

    {
      name: "Active",
      value: 15
    },

    {
      name: "Partial",
      value: 7
    }

  ];

  const inventoryData = [

    {
      name: "Available",
      stock: 80
    },

    {
      name: "Rented",
      stock: 20
    }

  ];

  const COLORS = [
    "#6366F1",
    "#10B981",
    "#F59E0B"
  ];

  return (

    <div className="min-h-screen bg-[#F5F7FB] p-4 md:p-6 space-y-6">

      {/* ========================================= */}
      {/* HERO */}
      {/* ========================================= */}

      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-3xl p-5 md:p-8 text-white shadow-xl">

        <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

          <div>

            <p className="uppercase tracking-widest text-indigo-200 text-sm">
              Rental ERP
            </p>

            <h1 className="text-2xl md:text-4xl font-bold mt-2">
              Dashboard Overview
            </h1>

            <p className="mt-3 text-indigo-100">
              Monitor rentals, payments,
              customers and inventory in real time.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-4">

  <input
    type="date"
    value={startDate}
    onChange={(e) =>
      setStartDate(
        e.target.value
      )
    }
    className="w-full sm:w-auto px-4 py-2 rounded-xl text-black"
  />

  <input
    type="date"
    value={endDate}
    onChange={(e) =>
      setEndDate(
        e.target.value
      )
    }
    className="px-4 py-2 rounded-xl text-black"
  />

  <button
    onClick={() => {

      setStartDate("");

      setEndDate("");

    }}
    className="w-full sm:w-auto bg-white/20 px-4 py-2 rounded-xl"
  >

    Reset

  </button>

</div>

          </div>

          <div className="hidden md:flex flex-col items-end">

            <div className="bg-white/10 backdrop-blur-md px-6 py-4 rounded-2xl border border-white/20">

              <p className="text-sm text-indigo-100">
                Total Revenue
              </p>

              <h2 className="text-4xl font-bold mt-1">
                ₹{stats.revenue || 0}
              </h2>

            </div>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* STATS */}
      {/* ========================================= */}

     <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition">

          <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

            <div>

              <p className="text-sm text-gray-500">
                Revenue
              </p>

              <h2 className="text-3xl font-bold text-green-600 mt-2">
                ₹{stats.revenue || 0}
              </h2>

            </div>

            <div className="w-14 h-14 rounded-2xl bg-green-100 flex items-center justify-center">

              <span className="text-2xl">
                💰
              </span>

            </div>

          </div>

        </div>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition">

          <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

            <div>

              <p className="text-sm text-gray-500">
                Customers
              </p>

              <h2 className="text-3xl font-bold text-indigo-600 mt-2">
                {stats.customers || 0}
              </h2>

            </div>

            <div className="w-14 h-14 rounded-2xl bg-indigo-100 flex items-center justify-center">

              <span className="text-2xl">
                👥
              </span>

            </div>

          </div>

        </div>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition">

          <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

            <div>

              <p className="text-sm text-gray-500">
                Rentals
              </p>

              <h2 className="text-3xl font-bold text-blue-600 mt-2">
                {stats.rentals || 0}
              </h2>

            </div>

            <div className="w-14 h-14 rounded-2xl bg-blue-100 flex items-center justify-center">

              <span className="text-2xl">
                📦
              </span>

            </div>

          </div>

        </div>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition">

          <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

            <div>

              <p className="text-sm text-gray-500">
                Products
              </p>

              <h2 className="text-3xl font-bold text-orange-500 mt-2">
                {products.length || 0}
              </h2>

            </div>

            <div className="w-14 h-14 rounded-2xl bg-orange-100 flex items-center justify-center">

              <span className="text-2xl">
                🛒
              </span>

            </div>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* CHARTS */}
      {/* ========================================= */}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

        {/* REVENUE */}

        <div className="col-span-1 lg:col-span-8 bg-white rounded-3xl p-5 md:p-6 shadow-sm border border-gray-100">

                <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4 mb-6">


            <div>

              <h2 className="text-xl font-bold text-gray-800">
                Revenue Analytics
              </h2>

              <p className="text-sm text-gray-500 mt-1">
                Monthly rental income overview
              </p>

            </div>

            <div className="bg-indigo-100 text-indigo-600 px-4 py-2 rounded-xl text-sm font-semibold">

              +18.4%

            </div>

          </div>

          <ResponsiveContainer
            width="100%"
            height={320}
          >

            <AreaChart
              data={revenueData}
            >

              <defs>

                <linearGradient
                  id="colorRevenue"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >

                  <stop
                    offset="5%"
                    stopColor="#6366F1"
                    stopOpacity={0.4}
                  />

                  <stop
                    offset="95%"
                    stopColor="#6366F1"
                    stopOpacity={0}
                  />

                </linearGradient>

              </defs>

              <CartesianGrid
                strokeDasharray="3 3"
                vertical={false}
              />

              <XAxis
                dataKey="month"
              />

              <YAxis />

              <Tooltip />

              <Area
                type="monotone"
                dataKey="revenue"
                stroke="#6366F1"
                strokeWidth={3}
                fillOpacity={1}
                fill="url(#colorRevenue)"
              />

            </AreaChart>

          </ResponsiveContainer>

        </div>

        {/* PIE */}

        <div className="col-span-1 lg:col-span-4 bg-white rounded-3xl p-5 md:p-6 shadow-sm border border-gray-100">

          <h2 className="text-xl font-bold text-gray-800">
            Rental Status
          </h2>

          <p className="text-sm text-gray-500 mt-1 mb-6">
            Current rental distribution
          </p>

          <ResponsiveContainer
            width="100%"
            height={280}
          >

            <PieChart>

              <Pie
                data={rentalStatusData}
                dataKey="value"
                innerRadius={60}
                outerRadius={90}
                paddingAngle={5}
              >

                {rentalStatusData.map(
                  (entry, index) => (

                    <Cell
                      key={index}
                      fill={
                        COLORS[index]
                      }
                    />

                  )
                )}

              </Pie>

              <Tooltip />

            </PieChart>

          </ResponsiveContainer>

          <div className="space-y-3 mt-4">

            {rentalStatusData.map(
              (item, index) => (

                <div
                  key={index}
                  className="flex justify-between items-center"
                >

                  <div className="flex items-center gap-3">

                    <div
                      className="w-3 h-3 rounded-full"
                      style={{
                        background:
                          COLORS[index]
                      }}
                    />

                    <p className="text-sm text-gray-600">
                      {item.name}
                    </p>

                  </div>

                  <p className="font-semibold">
                    {item.value}
                  </p>

                </div>

              )
            )}

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* SECOND ROW */}
      {/* ========================================= */}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

        {/* INVENTORY */}

        <div className="col-span-1 lg:col-span-5 bg-white rounded-3xl p-5 md:p-6 shadow-sm border border-gray-100">

          <h2 className="text-xl font-bold text-gray-800 mb-6">
            Inventory Overview
          </h2>

          <ResponsiveContainer
            width="100%"
            height={300}
          >

            <BarChart
              data={inventoryData}
            >

              <CartesianGrid
                strokeDasharray="3 3"
                vertical={false}
              />

              <XAxis
                dataKey="name"
              />

              <YAxis />

              <Tooltip />

              <Bar
                dataKey="stock"
                fill="#6366F1"
                radius={[
                  10,
                  10,
                  0,
                  0
                ]}
              />

            </BarChart>

          </ResponsiveContainer>

        </div>

        {/* PRODUCTS */}

       <div className="col-span-1 lg:col-span-7 bg-white rounded-3xl p-5 md:p-6 shadow-sm border border-gray-100">

        <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4 mb-6">

            <div>

              <h2 className="text-xl font-bold text-gray-800">
                Products
              </h2>

              <p className="text-sm text-gray-500 mt-1">
                Recently added products
              </p>

            </div>

            <button
              onClick={() =>
                navigate("/products")
              }
              className="text-indigo-600 font-medium hover:underline"
            >
              View All →
            </button>

          </div>

          <div className="overflow-x-auto">

            <table className="min-w-[850px] w-full">

              <thead>

                <tr className="text-left text-gray-500 border-b">

                  <th className="pb-4">
                    Product
                  </th>

                  <th>
                    Total
                  </th>

                  <th>
                    Available
                  </th>

                  <th>
                    Price
                  </th>

                </tr>

              </thead>

              <tbody>

                {products.map(p => (

                  <tr
                    key={p.id}
                    className="border-b hover:bg-gray-50 transition"
                  >

                    <td className="py-4 font-medium text-gray-700">
                      {p.name}
                    </td>

                    <td>
                      {p.total_quantity}
                    </td>

                    <td>

                      <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold">

                        {
                          p.available_quantity
                        }

                      </span>

                    </td>

                    <td className="font-semibold">
                      ₹{p.price_per_unit}
                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* CUSTOMERS */}
      {/* ========================================= */}

      <div className="bg-white rounded-3xl p-5 md:p-6 shadow-sm border border-gray-100">

        <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4 mb-6">

          <div>

            <h2 className="text-xl font-bold text-gray-800">
              Recent Customers
            </h2>

            <p className="text-sm text-gray-500 mt-1">
              Latest customer activity
            </p>

          </div>

          <button
            onClick={() =>
              navigate("/customers")
            }
            className="text-indigo-600 font-medium hover:underline"
          >
            View All →
          </button>

        </div>

        <div className="overflow-x-auto">

          <table className="min-w-[850px] w-full">

            <thead>

              <tr className="text-left text-gray-500 border-b">

                <th className="pb-4">
                  Customer
                </th>

                <th>
                  Phone
                </th>

                <th>
                  Address
                </th>

              </tr>

            </thead>

            <tbody>

              {customers.map(c => (

                <tr
                  key={c.id}
                  className="border-b hover:bg-gray-50 transition"
                >

                  <td className="py-4 font-medium text-gray-700">

                    {c.first_name}
                    {" "}
                    {c.last_name}

                  </td>

                  <td>
                    {c.phone}
                  </td>

                  <td>
                    {c.address || "-"}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
};

export default Dashboard;